export default "__VITE_ASSET__CreKRo6V__"